import { jwtDecode } from 'jwt-decode';
import TokenService from '../services/network/tokenService';

export const isAuthenticated = (token = null) => {
    const accessToken = token || TokenService.getAccessToken();

    if (accessToken) {
        try {
            const { exp } = jwtDecode(accessToken);
            const currentTime = Math.floor(Date.now() / 1000);
            return currentTime < exp;
        } catch (error) {
            return false;
        }
    }
    return false;
};
